import React from "react";
import Icon from "./Icon";

const EyeSvg = () => (
  <Icon name="eye" className=" h-6 w-6 text-blue-700 dark:text-white" strokeWidth="1.5" />
);

export default EyeSvg;
